import { LoanStatus } from '@willow/types-iso';

export function getComputedActiveStatus(status: LoanStatus, hasActiveBankruptcy: boolean): LoanStatus | 'bankruptcy' {
  if (hasActiveBankruptcy) {
    return 'bankruptcy';
  }

  if (status === 'preActive') {
    return 'active';
  }

  return status;
}

export function isValidLoanStatusChange(
  status: LoanStatus,
  newStatus: LoanStatus | 'bankruptcy',
  hasUntrackedPayoff: boolean,
  hasActiveBankruptcy: boolean,
  isAdmin: boolean,
): boolean {
  switch (status) {
    case 'preActive':
    case 'active':
      return hasActiveBankruptcy
        ? ['active', 'pendingTransfer', 'paidOff', 'foreclosure', 'archived'].includes(newStatus)
        : true; // All options allowed
    case 'archived':
      return isAdmin && ['active'].includes(newStatus); // Only super admins are allowed to change archived loans -> active
    case 'pendingActivation':
      return ['active', 'preActive', 'archived'].includes(newStatus);
    case 'pendingTransfer':
      return ['preActive', 'active', 'transferred', 'paidOff', 'foreclosure'].includes(newStatus);
    case 'transferred':
      return ['archived'].includes(newStatus);
    case 'foreclosure':
      // Note: there is future work needed when changing from foreclosure to active status (i think its for reporting purposes?)
      // but while we were previously blocking this behavior in reality, we were just doing manual loan surgery to update the status
      return ['active', 'paidOff', 'archived'].includes(newStatus);
    case 'paidOff':
      // allow untracked payoffs to be reverted to active status
      const allowedStatuses = hasUntrackedPayoff ? ['active', 'archived'] : ['archived'];
      return allowedStatuses.includes(newStatus);
    case 'reo':
      // Note: there is future work needed when changing from reo to active status (i think its for reporting purposes?)
      // but while we were previously blocking this behavior in reality, we were just doing manual loan surgery to update the status
      return ['liquidated', 'archived', 'active'].includes(newStatus);
    case 'liquidated':
      return ['archived'].includes(newStatus);
    default:
      return false;
  }
}

export function shouldRescindGoodbye(oldStatus: LoanStatus, newStatus: LoanStatus): boolean {
  return (
    (oldStatus === 'pendingTransfer' || oldStatus === 'transferred') &&
    ['active', 'paidOff', 'foreclosure'].includes(newStatus)
  );
}
